import { useCallback, useEffect, useState } from 'react'
import { fetchHarbourVenueDrawer } from 'src/utils/harbourApi'

/**
 * Drawer GET for one venue id. Used on card/search open and on
 * `?tab=harbour&venue=` even when the venue is not on the current board.
 */
export function useHarbourDrawer({ venueId, enabled = true } = {}) {
  const [drawer, setDrawer] = useState(null)
  const [loading, setLoading] = useState(Boolean(enabled && venueId))
  const [error, setError] = useState(null)
  const [reloadToken, setReloadToken] = useState(0)

  const refresh = useCallback(() => {
    setReloadToken(token => token + 1)
  }, [])

  useEffect(() => {
    if (!enabled || !venueId) {
      setDrawer(null)
      setLoading(false)
      setError(null)
      return undefined
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    async function loadDrawer() {
      try {
        const next = await fetchHarbourVenueDrawer(venueId)
        if (cancelled) {
          return
        }
        setDrawer(next)
      } catch (err) {
        if (cancelled) {
          return
        }
        setDrawer(null)
        setError(err.message || 'Failed to load Harbour venue')
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadDrawer()

    return () => {
      cancelled = true
    }
  }, [venueId, enabled, reloadToken])

  return { drawer, loading, error, refresh }
}
